(function () {
  var NUMBER_PATTERN = /^([^\d]*)([\d][\d.,\s]*)(.*)$/;

  function parseNumber(raw) {
    var match = String(raw || '').match(NUMBER_PATTERN);
    if (!match) return null;

    var digits = match[2].replace(/\s+$/, '');
    var trailing = match[2].slice(digits.length);
    var decimalSeparator = '';
    var decimals = 0;

    // The last "." or "," is a decimal separator only when it is followed by 1-2 digits
    // and the digits are not grouped in threes (e.g. "9.5" vs "1,234").
    var decimalMatch = digits.match(/[.,](\d{1,2})$/);
    if (decimalMatch && !/^\d{1,3}([.,]\d{3})+$/.test(digits)) {
      decimalSeparator = decimalMatch[0].charAt(0);
      decimals = decimalMatch[1].length;
    }

    var plain = decimalSeparator
      ? digits.slice(0, digits.length - decimals - 1).replace(/[.,\s]/g, '') + '.' + decimalMatch[1]
      : digits.replace(/[.,\s]/g, '');

    var value = parseFloat(plain);
    if (isNaN(value)) return null;

    return {
      prefix: match[1],
      suffix: trailing + match[3],
      value: value,
      decimals: decimals,
      decimalSeparator: decimalSeparator || '.',
      grouped: /[.,]\d{3}/.test(digits),
      groupSeparator: (digits.match(/([.,])\d{3}/) || [])[1] || ','
    };
  }

  function formatNumber(value, parsed) {
    var fixed = value.toFixed(parsed.decimals);
    var parts = fixed.split('.');
    var whole = parts[0];

    if (parsed.grouped) {
      whole = whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + parsed.groupSeparator);
    }

    return parts[1] ? whole + parsed.decimalSeparator + parts[1] : whole;
  }

  function animate(el, parsed, duration) {
    var start = null;

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = parsed.prefix + formatNumber(parsed.value * eased, parsed) + parsed.suffix;
      if (progress < 1) window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);
  }

  function run(el) {
    if (el.dataset.statsDone === 'true') return;
    el.dataset.statsDone = 'true';

    var raw = el.getAttribute('data-stats-value') || el.textContent;
    var parsed = parseNumber(raw);
    var duration = Number(el.getAttribute('data-stats-duration')) || 1600;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!parsed || reduced || duration <= 0) {
      el.textContent = raw;
      return;
    }

    el.textContent = parsed.prefix + formatNumber(0, parsed) + parsed.suffix;
    animate(el, parsed, duration);
  }

  function observe(root) {
    var targets = root.querySelectorAll('[data-stats-number]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(run);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          run(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.35 }
    );

    targets.forEach(function (target) {
      observer.observe(target);
    });
  }

  function init(root) {
    if (root.dataset.statsReady === 'true') return;
    root.dataset.statsReady = 'true';
    observe(root);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.mt-womo-stats').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
